import { ProductionOrdersIndex } from "@/features/production-orders";

// Página de Ordens de Produção (rota /orders). Orquestração vive no feature index.
export function ProductionOrdersPage() {
  return <ProductionOrdersIndex />;
}
